(function () {
  'use strict';

  var SECTION_ID = 'quick-view';
  var PREFETCH_CACHE = new Map();

  var root = null;
  var target = null;
  var loadingHTML = '';
  var controller = null;

  function cache() {
    if (root) return true;

    root = document.querySelector('[data-overlay="quick-view"]');
    if (!root) return false;

    target = root.querySelector('[data-quick-view-target]');
    loadingHTML = target ? target.innerHTML : '';
    return Boolean(target);
  }

  function buildUrl(href) {
    var url = new URL(href, window.location.origin);
    url.searchParams.set('section_id', SECTION_ID);
    return url.toString();
  }

  function fetchQuickView(href, signal) {
    var url = buildUrl(href);

    if (PREFETCH_CACHE.has(url)) {
      return PREFETCH_CACHE.get(url);
    }

    var request = fetch(url, { signal: signal, priority: 'high' })
      .then(function (response) {
        if (!response.ok) throw new Error(response.statusText);
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var content = parsed.querySelector('[data-quick-view-content]');
        if (!content) throw new Error('Quick view section is empty');
        return content.outerHTML;
      });

    PREFETCH_CACHE.set(url, request);
    request.catch(function () {
      PREFETCH_CACHE.delete(url);
    });

    return request;
  }

  function prefetch(href) {
    if (!href) return;
    fetchQuickView(href).catch(function () {});
  }

  function open(href) {
    if (!cache()) return;

    if (controller) controller.abort();
    controller = new AbortController();

    target.innerHTML = loadingHTML;
    window.Duncan.openOverlay(root);

    fetchQuickView(href, controller.signal)
      .then(function (contentHTML) {
        target.innerHTML = contentHTML;

        var heading = target.querySelector('[data-overlay-autofocus]');
        if (heading) heading.focus();
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;

        window.Duncan.closeOverlay(root);
        window.location.href = href;
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quick-view]');
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();
    open(trigger.dataset.quickView);
  });

  // mouseenter doesn't bubble, so delegate on the capture phase
  document.addEventListener('mouseenter', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-quick-view]');
    if (trigger) prefetch(trigger.dataset.quickView);
  }, true);

  document.addEventListener('touchstart', function (event) {
    var trigger = event.target.closest('[data-quick-view]');
    if (trigger) prefetch(trigger.dataset.quickView);
  }, { passive: true });

  document.addEventListener('cart:added', function () {
    if (root && !root.hidden) window.Duncan.closeOverlay(root);
  });
})();